module.exports = __webpack_public_path__ + "assets/img/swiper-2-1.a0146cfa.jpg";